const getResidenceOptionsList = (lang) => ([
  { value: 1, label: lang['REGISTRATION.RESIDENCE_CONFIRMATION_YES'] },
  { value: 0, label: lang['REGISTRATION.RESIDENCE_CONFIRMATION_NO'] },
]);

export default getResidenceOptionsList;
